// TODO: убрать импорт package.json
import { version } from '@/resources/../../package.json';

const getAppVersion = () => version;

export default getAppVersion;
